import { useTheme } from 'styled-components';
import { IconKeys } from '../../../../components/common/Icon/IconKeys';
import Tags from '../../../../components/common/Tags';
import { generateDistance } from '../../../../utils/unitsUtils';
import { generatePreviewFullName } from '../../../Drivers/Modals/helpers';
import { DriverAndVehicle } from '../../types';
import S from './SearchEntityStyles';
import useDriverThumbnail from '../../../../theme/useDriverThumbnail';
import { ThemeType } from '../../../../theme/themeType';
import { generateScoreColor, getScoreLabel, hasDisplayableEntityScore } from '../../../../utils/commonUtils';

type Props = {
  data: DriverAndVehicle;
  isChecked: boolean;
  entity: string;
  selectEntity: (driver: DriverAndVehicle) => void;
  assignEntity: (driver: DriverAndVehicle) => void;
};

function Driver({
  data, isChecked, selectEntity, entity, assignEntity,
}: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const driverThumbnail = useDriverThumbnail();
  const {
    _id: driverId,
    distanceInKmTotal,
    firstName,
    lastName,
    avatarUrl,
    licenseName,
    licensePlateNumber,
    model,
    score,
  } = data;

  const title = entity === 'driver'
    ? generatePreviewFullName(firstName, lastName)
    : licensePlateNumber;
  const subtitle = entity === 'driver' ? licenseName : model;

  return (
    <S.DriverWrapper
      onClick={() => selectEntity(data)}
      onDoubleClick={() => assignEntity(data)}
    >
      <input type="radio" name="sort-by" id={driverId} checked={isChecked} disabled />
      <label htmlFor={driverId}>
        {hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label={getScoreLabel(score)} backgroundColor={generateScoreColor(score)} />
        )}
        {!hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label="No score" backgroundColor={theme.colors.outline} title="This vehicle didn't have any trips yet." />
        )}
        <span className="checkbox" />
      </label>
      <Tags.ItemOverview
        avatar={avatarUrl || driverThumbnail}
        avatarAlt="driver"
        title={title}
        subtitle={subtitle as string}
      />
      <div className="tags-container">
        <Tags.LabeledIcon
          label={generateDistance(distanceInKmTotal, true)}
          icon={IconKeys.DISTANCE}
        />
      </div>
    </S.DriverWrapper>
  );
}

export default Driver;
